import getPricingFromField from './getPricingFromField';

const priceSelectionList = (fieldNames, formFields) => {
  const priceSelections = {};
  fieldNames.forEach(fieldName => {
    priceSelections[fieldName] = getPricingFromField(formFields[fieldName]);
  });
  return priceSelections;
};

export default priceSelectionList;
